import { ReportsActions } from "../actions/reports";
import { StatementDto } from "../dto";
import { addToLoadingQueue, removeFromLoadingQueue } from "../utils";

export interface ReportsState {
  loadingQueue: string[];
  statements: StatementDto[];
}

const defaultState: ReportsState = {
  loadingQueue: [],
  statements: [],
};

export default function reportsReducer(
  state = defaultState,
  action: any
): ReportsState {
  switch (action.type) {
    case ReportsActions.REQUEST_GET_STATEMENTS:
      return {
        ...state,
        loadingQueue: addToLoadingQueue(state.loadingQueue, action.type),
      };
    case `${ReportsActions.REQUEST_GET_STATEMENTS}_SUCCESS`:
      return {
        ...state,
        loadingQueue: removeFromLoadingQueue(state.loadingQueue, action.type),
        statements: action.payload,
      };
    case `${ReportsActions.REQUEST_GET_STATEMENTS}_FAILURE`:
      return {
        ...state,
        loadingQueue: removeFromLoadingQueue(state.loadingQueue, action.type),
      };
    default:
      return state;
  }
}
